import type { SupportedExperimentVariants } from '../utils/types';

/**
 * The total number of variants in an experiment (control included), which determines
 * the test type. Named by the English word for the count so configs read as the test
 * shape rather than a bare number:
 * - `Two` → A/B (`control`, `treatment`) — binary
 * - `Three` → A/B/C (`control`, `treatment1`, `treatment2`)
 * - `Four` → A/B/C/D (adds `treatment3`)
 * - `Five` → A/B/C/D/E (adds `treatment4`)
 */
export const ExperimentVariantCount = {
  Two: 2,
  Three: 3,
  Four: 4,
  Five: 5,
} as const;

export type ExperimentVariantType =
  (typeof ExperimentVariantCount)[keyof typeof ExperimentVariantCount];

/**
 * The multivariate treatment variants in bucketing order. Slice by an experiment's
 * treatment count to get its active treatments: 2 → A/B/C, 3 → A/B/C/D, 4 → A/B/C/D/E.
 * Lives here (a neutral absmartly module) so both `@repo/absmartly` and `@repo/supergraph`
 * can import it without absmartly taking a dependency on supergraph.
 */
export const STATIC_EXPERIMENT_MULTI_TREATMENTS = [
  'treatment1',
  'treatment2',
  'treatment3',
  'treatment4',
] as const satisfies readonly SupportedExperimentVariants[];
